<template>
  <div
    :class="getDelayMessageFetchLoading && 'bg-white'"
    class="flex-auto px-4 lg:px-10 py-10 pt-0"
  >
    <div
      v-if="getDelayMessageFetchLoading"
      class="bg-white w-full flex flex-col py-10 justify-center items-center"
    >
      <!-- https://gannon.tv/intro -->
      <img width="260" src="@/assets/imgs/loading.gif" alt="loading" />
      <h3>Loading...</h3>
    </div>
    <div v-else class="m-4">
      <div
        class="flex justify-between block uppercase text-blueGray-600 text-xs font-bold mb-2"
      >
        <AttrTitleWithDescription
          :title="'Email Delay Message'"
          :description="'Email delay message'"
        />
        <div class="flex h-8">
          <button
            @click="handleUpdate"
            type="button"
            class="bg-emerald-500 inline-flex items-center active:bg-emerald-600 text-white font-bold uppercase text-xs px-4 rounded shadow hover:shadow-md outline-none focus:outline-none sease-linear transition-all mr-2 duration-150"
          >
            Save
            <IconSync
              class="animate-spin"
              v-if="getDelayMessageUpdateLoading"
            /></button
          ><button
            @click="handleClear"
            type="button"
            class="bg-white text-gray-500 font-bold uppercase text-xs px-4 rounded shadow hover:shadow-md outline-none focus:outline-none sease-linear transition-all duration-150"
          >
            Clear
          </button>
        </div>
      </div>
      <textarea
        type="text"
        v-model="formDataLocal['delayMessage']"
        class="h-40 border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as Actions from "@/store/actions.type";
import AttrTitleWithDescription from "@/components/Shared/Headers/AttrTitleWithDescription";
import IconSync from "@/assets/icons/IconSync";

export default {
  name: "NoticeEditPageForm",
  components: { AttrTitleWithDescription, IconSync },
  mounted() {
    // Fetch the delay message
    this.$store
      .dispatch(Actions.FETCH_DELAY_MESSAGE, {
        region: this.getRegion
      })
      .then(() => {
        this.formDataLocal.delayMessage = this.getEmailDelayMessage;
      });
  },
  props: { formData: { type: Object, required: true } },
  computed: {
    formDataLocal: {
      get: function () {
        return this.formData;
      },
      set: function (val) {
        this.$emit("update:formData", val);
      }
    },
    ...mapGetters([
      "getRegion",
      "getEmailDelayMessage",
      "getDelayMessageUpdateLoading",
      "getDelayMessageFetchLoading"
    ])
  },
  methods: {
    handleClear() {
      this.formDataLocal.delayMessage = "";
    },
    handleUpdate() {
      this.$store.dispatch(Actions.UPDATE_DELAY_MESSAGE, {
        region: this.getRegion,
        data: {
          delayMessage: this.formDataLocal.delayMessage
        }
      });
    }
  }
};
</script>
